import type { QuestionnaireSchema } from '@gba/questionnaire-antd';
import {
  Core,
  QUESTIONNAIRE_RESPONSE,
  QUESTIONNAIRE_RESPONSE_SUBMIT,
  QUESTIONNAIRE_RESPONSES,
  QUESTIONNAIRE_TEMPLATE,
} from '../Core';
import type {
  PagedQuestionnaireResponses,
  QuestionnaireResponseDetail,
  QuestionnaireResponsesQuery,
  QuestionnaireTemplateParams,
  SubmitQuestionnaireResponseBody,
} from './types';

class Questionnaire extends Core {
  getTemplate = async (params: QuestionnaireTemplateParams) =>
    this.get<QuestionnaireSchema>(QUESTIONNAIRE_TEMPLATE(), params);

  submitResponse = async (body: SubmitQuestionnaireResponseBody) =>
    this.post<{ responseId: number }>(QUESTIONNAIRE_RESPONSE_SUBMIT(), body);

  getResponse = async (responseId: number) =>
    this.get<QuestionnaireResponseDetail>(QUESTIONNAIRE_RESPONSE(responseId));

  listResponses = async (query: QuestionnaireResponsesQuery) =>
    this.get<PagedQuestionnaireResponses>(QUESTIONNAIRE_RESPONSES(query));
}

export const questionnaire = new Questionnaire();
